import { MAX_VALUE_AMOUNT, MIN_VALUE_AMOUNT } from '@/components/constants';
import { InvoiceReportsSearchFormData } from '@/features/invoice_reports/components/Search/hooks/useSearchForm';
import { PropsControl } from '@/features/invoice_reports/components/Search/type';
import {
  FormInputNumber,
  InputNumberProps,
} from '@moneyforward/ap-frontend-components';
import { FC, memo, useMemo } from 'react';

export const Amount: FC<PropsControl> = memo(({ control, name }) => {
  const inputProps: InputNumberProps = useMemo(
    () => ({
      format: 'price_with_empty',
      max: MAX_VALUE_AMOUNT,
      min: MIN_VALUE_AMOUNT,
      stringMode: true,
      size: 'small',
    }),
    []
  );
  return (
    <FormInputNumber<InvoiceReportsSearchFormData>
      control={control}
      name={name}
      inputId='amount'
      inputProps={inputProps}
      testId='amount'
    />
  );
});
Amount.displayName = 'Amount';
